"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SETTINGS_FRAGMENT = void 0;
var helpers_1 = require("../../client/helpers");
exports.SETTINGS_FRAGMENT = "\n  fragment SettingsFragment on Settings {\n    defaultChannelId\n    currency\n    defaultPricing {\n      type\n      price\n      period\n      enabled\n    }\n    extendOptions\n    embedLogos {\n      selected\n      default\n    }\n  }\n";
//# sourceMappingURL=settings.fragments.js.map